import React from "react";
import { motion } from "framer-motion";
import "./../styles/module.css";
import { useState } from "react";
import Footer from "../components/Footer.js"



const Modules = () =>{

    const [openWeek, setOpenWeek] = useState(null);

  const toggle = (week) => {
    setOpenWeek(openWeek === week ? null : week);
  };
// ======
    
    return(
        <>
        <motion.div 
             
             className="hero-section"
                       initial={{ opacity: 0, y: -50 }}
                       animate={{ opacity: 1, y: 0 }}
                       transition={{ duration: 0.5 }}>
 {/* ======================first main part or erp module ========================== */}

  <div className="erp-wrapper">
  <h2 className="erp-heading">ERP Modules</h2>
  <p className="erp-subheading">
    Streamline your business processes with our integrated ERP solutions.
  </p>

  <div className="erp-modules-grid">
    <div className="erp-module-card">
      <div className="erp-icon">👔</div>
      <h3 className="erp-module-title">HR Management</h3>
      <p className="erp-module-desc">Manage employee records, payroll, and recruitment.</p>
    </div>
    <div className="erp-module-card">
      <div className="erp-icon">📦</div>
      <h3 className="erp-module-title">Inventory</h3>
      <p className="erp-module-desc">Track stock levels, orders and deliveries.</p>
    </div>
    <div className="erp-module-card">
      <div className="erp-icon">💲</div>
      <h3 className="erp-module-title">Finance</h3>
      <p className="erp-module-desc">Handle accounting, budgeting, and financial reporting.</p>
    </div>
    <div className="erp-module-card">
      <div className="erp-icon">📈</div>
      <h3 className="erp-module-title">Sales</h3>
      <p className="erp-module-desc">Optimize sales processes and customer relationships.</p>
    </div>
  </div>
</div>

{/* ============================== second pary of erp module ===================================== */}
<div className="maind">

<div className="timeline-container">
      <h1 className="title">IMPLEMENTATION</h1>
      <h2 className="subtitle">TIMELINE</h2>

      {/* WEEK 1 */}
      <div className="card">
        <div className="card-header week-1" onClick={() => toggle(1)}>
          <span>WEEK 1</span>
          <span>{openWeek === 1 ? "▲" : "▼"}</span>
        </div>
        <h3>1. PROJECT INITIATION PHASE</h3>
        {openWeek === 1 && (
          <ul className="card-body">
            <li>Define project scope and objectives</li>
            <li>Identify stakeholders and establish communication channels</li>
          </ul>
        )}
      </div>

      {/* WEEK 2 */}
      <div className="card">
        <div className="card-header week-2" onClick={() => toggle(2)}>
          <span>WEEK 2</span>
          <span>{openWeek === 2 ? "▲" : "▼"}</span>
        </div>
        <h3>2. PLANNING PHASE</h3>
        {openWeek === 2 && (
          <ul className="card-body">
            <li>Conduct market research and gather requirements</li>
            <li>Develop a detailed project plan</li>
            <li>Create wireframes and mockups for the app</li>
          </ul>
        )}
      </div>

      {/* WEEK 3 */}
      <div className="card">
        <div className="card-header week-3" onClick={() => toggle(3)}>
          <span>WEEK 3</span>
          <span>{openWeek === 3 ? "▲" : "▼"}</span>
        </div>
        <h3>3. DESIGN PHASE</h3>
        {openWeek === 3 && (
          <ul className="card-body">
            <li>Finalize app design based on wireframes and mockups</li>
            <li>Develop the UI and UX</li>
            <li>Review and approve the design with stakeholders</li>
          </ul>
        )}
      </div>

      {/* WEEK 4 */}
      <div className="card">
        <div className="card-header week-4" onClick={() => toggle(4)}>
          <span>WEEK 4</span>
          <span>{openWeek === 4 ? "▲" : "▼"}</span>
        </div>
        <h3>4. DEVELOPMENT PHASE</h3>
        {openWeek === 4 && (
          <ul className="card-body">
            <li>Set up development environment and infrastructure</li>
            <li>Develop backend and frontend of the app</li>
          </ul>
        )}
      </div>

      {/* WEEK 5 */}
      <div className="card">
        <div className="card-header week-5" onClick={() => toggle(5)}>
          <span>WEEK 5</span>
          <span>{openWeek === 5 ? "▲" : "▼"}</span>
        </div>
        <h3>5. TESTING AND QUALITY ASSURANCE</h3>
        {openWeek === 5 && (
          <ul className="card-body">
            <li>Conduct alpha testing among the development team</li>
            <li>Perform beta testing with a select group of users</li>
            <li>Address and fix any reported bugs</li>
          </ul>
        )}
      </div>

      {/* WEEK 6 */}
      <div className="card">
        <div className="card-header week-6" onClick={() => toggle(6)}>
          <span>WEEK 6</span>
          <span>{openWeek === 6 ? "▲" : "▼"}</span>
        </div>
        <h3>6. DEPLOYMENT PHASE</h3>
        {openWeek === 6 && (
          <ul className="card-body">
            <li>Prapare for the app depeloyment to app stores</li>
            <li>Submit the app to google play store and apple app store</li>
            <li>Moniter the app after release and handle any issues</li>
          </ul>
        )}
      </div>

{/* WEEK 7 */}
<div className="card">
        <div className="card-header week-7" onClick={() => toggle(7)}>
          <span>WEEK 7</span>
          <span>{openWeek === 7 ? "▲" : "▼"}</span>
        </div>
        <h3>7. PROJECT CLOSURE PHASE</h3>
        {openWeek === 7 && (
          <ul className="card-body">
            <li>Evaluate Project succes and deliverables</li>
            <li>Conduct a project review and document lessons learned</li>
            <li>Celebrate the succesful completion of the project</li>
          </ul>
        )}
      </div>

    </div>
     
    </div>

 </motion.div><br></br>
 <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
 <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
 <br></br><br></br><br></br><br></br><br></br><br></br><br></br>

<Footer/>
        
        </>
    )
}
export default Modules;